import { z } from 'zod';
/** `GET /health` on the API. Used by Railway healthchecks and the smoke tests. */
export const HealthDto = z.object({
    status: z.enum(['ok', 'degraded']),
    uptimeSeconds: z.number().nonnegative(),
    version: z.string(),
    checks: z.object({
        database: z.object({
            status: z.enum(['up', 'down']),
            latencyMs: z.number().nonnegative().optional(),
        }),
    }),
});
//# sourceMappingURL=health.js.map